import jwtDecode from "jwt-decode";

export const authProvider = {
    login: ({ username, password }) => {
        const request = new Request(`${process.env.REACT_APP_URL}/auth/admin`, {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                if (response.status === 401) {
                    return Promise.reject()
                    // throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(auth => {
                localStorage.setItem('token', JSON.stringify(auth.access_token));
                const decodedToken = jwtDecode(auth.access_token);
                localStorage.setItem("permissions", decodedToken.claims.role);
                localStorage.setItem("states", JSON.stringify(auth.states || []));
            })
            .catch(() => {
                return Promise.reject()
                // throw new Error('bad cridintial')
            });

        // if (username !== "ahmed" || password !== "123456") {
        //     return Promise.reject()
        // } else {
        //     localStorage.setItem('token', "ahmed");
        //     return Promise.resolve();
        // }
    },

    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    },

    // checkAuth: params => {
    //     if (localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined) {
    //         return Promise.resolve()
    //     } else {
    //         return Promise.reject()
    //     }
    // },
    checkAuth: () => {
        const token = localStorage.getItem('token');
        return token ? Promise.resolve() : Promise.reject();
    },
    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem("permissions");
        localStorage.removeItem("states");
        return Promise.resolve();
    },
    getIdentity: () => Promise.resolve(),
    getPermissions: params => {
         const role = localStorage.getItem("permissions");
         return role ? Promise.resolve(role) : Promise.reject();
    },
};

